export default "__VITE_ASSET__DsdZa5ho__"